export default {
  namespaced: true,

  state: () => ({
    vouchers: {
      data: [],
      links: {},
      meta: {},
    },
    voucher: {},
    loading: false,
  }),

  mutations: {
    SET_VOUCHER_LIST(state, payload) {
      state.vouchers = payload
    },
    SET_VOUCHER_DETAIL(state, payload) {
      state.voucher = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
  },

  actions: {
    async getVoucherList({ commit }, { page = null, limit = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)

        const params = {
          sort: '-created_at',
          page,
          limit,
        }

        if (keyword) {
          params['filter[code]'] = keyword
        }

        const response = await this._vm.$http.get('/v1/admin/vouchers', { params })

        commit('SET_VOUCHER_LIST', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    async getVoucherDetail({ commit }, { voucherId }) {
      try {
        const url = `/v1/admin/vouchers/${voucherId}`

        const response = await this._vm.$http.get(url)

        commit('SET_VOUCHER_DETAIL', response.data.data)

        return response.data.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    async createVoucher(context, data) {
      try {
        const url = '/v1/admin/vouchers'

        const response = await this._vm.$http.post(url, data)

        return response.data
      } catch (error) {
        throw new Error(error)
      }
    },
    async editVoucher(context, { voucherId, data }) {
      try {
        const url = `/v1/admin/vouchers/${voucherId}`

        const response = await this._vm.$http.put(url, data)

        return response.data
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}
